import Date from "./date";
import Link from "next/link";
import Avatar from "./avatar";
import { cx } from "@/lib/all";
import CoverImage from "./cover-image";
import CategoryLabel from "@/components/blog/category";

export default function PostPreview({
  title,
  coverImage,
  date,
  excerpt,
  author,
  slug,
  aspect,
  categories,
}) {
  return (
    <>
      <div className="cursor-pointer group">
        <div
          className={cx(
            "relative overflow-hidden transition-all bg-gray-100 rounded-md hover:scale-105",
            aspect === "landscape" ? "aspect-video" : "aspect-square"
          )}
        >
          {coverImage && (
            <CoverImage title={title} coverImage={coverImage} slug={slug} />
          )}
        </div>

        <CategoryLabel categories={categories} />

        <h3 className="mt-2 text-lg font-semibold tracking-normal text-brand-primary text-red">
          <Link href={`/blog/${slug}`} title={title}>
            <span className="bg-gradient-to-r from-green-200 text-primary to-green-100 bg-[length:0px_10px] bg-left-bottom bg-no-repeat transition-[background-size] duration-500 hover:bg-[length:100%_3px] group-hover:bg-[length:100%_10px]">
              {title}
            </span>
          </Link>
        </h3>

        <div className="hidden">
          {excerpt && (
            <Link href={`/blog/${slug}`} title={title}>
              <span
                className="mt-2 text-sm text-gray-500 line-clamp-3"
                dangerouslySetInnerHTML={{ __html: excerpt }}
              ></span>
            </Link>
          )}
        </div>

        <div className="flex items-center mt-3 space-x-3 text-gray-500">
          <Avatar author={author} />
          <span className="text-xs text-gray-300">&bull;</span>

          <Date dateString={date} />
        </div>
      </div>
    </>
  );
}
